function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M70.136,25.354v.935H69.2a.935.935,0,0,0-.935.935V42.179a.935.935,0,0,0,.935.935H87.9a.935.935,0,0,0,.935-.935V27.223a.935.935,0,0,0-.935-.935H72.006v-.935A6.543,6.543,0,0,1,84.616,22.9a.935.935,0,0,0,1.733-.7,8.412,8.412,0,0,0-16.213,3.156Zm16.825,15.89H70.136V28.158H86.961Z",
  transform: "translate(-68.267 -16.934)",
  fill: "#cdcdcd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M206.656,278.289v2.042a.935.935,0,0,0,1.87,0v-2.042a2.8,2.8,0,1,0-1.87,0Zm.935-3.567a.935.935,0,1,1-.935.935A.935.935,0,0,1,207.591,274.723Z",
  transform: "translate(-197.309 -258.825)",
  fill: "#cdcdcd"
}));

function SvgIconLocker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.564,
    height: 26.18,
    viewBox: "0 0 20.564 26.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocker);
export default __webpack_public_path__ + "static/media/icon-locker.a935d800.svg";
export { ForwardRef as ReactComponent };